import React from 'react'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import {UserSolutionDto} from 'learndb-share'
import {SolutionSql} from '../components/SolutionSql'

interface IMySolutionProps {
  id: string
}

const MySolution: React.FC<IMySolutionProps> = (): React.ReactElement => {
  const userSolution = useSelector<IReduxState, UserSolutionDto | undefined>((state) => state.task?.userSolution)
  const solution = userSolution?.solution

  return <SolutionSql sql={solution} />
}

export {MySolution}
